export const common = {
  // Navigation
  home: 'Home',
  services: 'Services',
  programs: 'Programs',
  members: 'Members/Companies',
  about: 'About Us',
  
  // Hero Section
  heroTitle: 'We help Taiwanese Business',
  heroSubtitle: 'Enter US Market',
  heroDescription: 'Comprehensive support for Taiwanese companies expanding into the United States. From market entry to business setup, we provide the expertise and resources you need.',
  createProfile: 'Create Profile',
  
  // Common
  learnMore: 'Learn More',
  getStarted: 'Get Started',
  contactUs: 'Contact Us',
};